import _ from 'lodash'
import { Message } from 'element-ui'
import { publishCustom } from '@/api/creative/custom.js'

/**
 * 发布非 dco 素材到 pt
 * @param {any} param0
 */
export default async function({ state }) {
  if (state.isReadonly) {
    Message({
      message: 'Read Only',
      type: 'error',
      duration: 5 * 1000
    })
    return false
  }

  try {
    state.customPublishing = true
    const res = await publishCustom({ custom_id: state.id })
    state.customPublishing = false
    return _.get(res, 'data.code') === 0
  } catch (e) {
    state.customPublishing = false
    return false
  }
}
